import Alpine from 'alpinejs'

const formDirtyTracker = () => ({
  isDirty: false,
  initialSnapshot: '',
  observer: null,
  checkDirtyTimeout: null,

  init() {
    // 等待 DOM 和 Alpine 組件完全初始化
    this.$nextTick(() => {
      setTimeout(() => {
        this.initialSnapshot = this.captureFormSnapshot()
        this.setupListeners()
      }, 100)
    })
  },

  captureFormSnapshot() {
    const form = this.$el
    if (!form) return ''

    // 擷取所有 input/select/textarea 的值
    const inputs = form.querySelectorAll('input, select, textarea')
    const values = Array.from(inputs)
      .filter(el => {
        if (!el.name) return false
        if (el.name.includes('authenticity_token')) return false
        // 過濾掉 Alpine.js 動態生成的 JSON 欄位 (如 attributes_data)
        // 這些欄位的序列化順序可能會變化,導致誤判
        if (el.name.includes('attributes_data')) return false
        if (el.type === 'hidden' && el.value && el.value.startsWith('[{')) return false
        if (el.type === 'hidden' && el.value && el.value.startsWith('{')) return false
        return true
      })
      .map(el => `${el.name}=${el.type === 'checkbox' ? el.checked : el.value}`)
      .sort()
      .join('|')

    // 也擷取隱藏欄位的數量（Alpine 動態生成的 nested attributes）
    const hiddenCount = form.querySelectorAll('input[type="hidden"][name*="_destroy"]').length
    return `${values}::hidden:${hiddenCount}`
  },

  setupListeners() {
    const form = this.$el
    if (!form) return

    // 監聽標準表單事件 (使用 debounced 版本來處理 Alpine.js x-model 的非同步更新)
    form.addEventListener('input', () => this.checkDirtyDebounced())
    form.addEventListener('change', () => this.checkDirtyDebounced())

    // 使用 MutationObserver 監聯 DOM 變化（Alpine 動態產生的元素）
    this.observer = new MutationObserver(() => {
      this.checkDirtyDebounced()
    })

    this.observer.observe(form, {
      childList: true,  // 監聽動態新增/移除的欄位 (如 Alpine.js 新增商品/方案)
      subtree: true     // 監聽所有後代元素
      // 不監聽 attributes,避免 Alpine.js 動態 binding 觸發誤判
    })
  },

  checkDirtyDebounced() {
    // 清除之前的 timeout
    if (this.checkDirtyTimeout) {
      clearTimeout(this.checkDirtyTimeout)
    }

    // 延遲執行,等待 Alpine.js 完成 DOM 更新
    this.checkDirtyTimeout = setTimeout(() => {
      this.checkDirty()
    }, 50)
  },

  checkDirty() {
    const currentSnapshot = this.captureFormSnapshot()
    const wasDirty = this.isDirty
    this.isDirty = currentSnapshot !== this.initialSnapshot

    window.dispatchEvent(new CustomEvent('form-dirty-changed', { detail: { isDirty: this.isDirty } }))
  },

  markClean() {
    this.initialSnapshot = this.captureFormSnapshot()
    this.isDirty = false
    window.dispatchEvent(new CustomEvent('form-dirty-changed', { detail: { isDirty: false } }))
  },

  destroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.checkDirtyTimeout) {
      clearTimeout(this.checkDirtyTimeout)
    }
  }
})

Alpine.data('formDirtyTracker', formDirtyTracker)
export default formDirtyTracker